const loginZh = {
  //登录公用
  loginCommon: {
    登录: '登录',
    请选择: '请选择',
    请输入登录邮箱与密码: '请输入登录邮箱与密码',
    账号: '账号',
    请输入账号: '请输入账号',
    密码: '密码',
    请输入密码: '请输入密码',
    记住密码: '记住密码',
    我已阅读并同意: '我已阅读并同意',
    隐私协议: '隐私协议',
    登录中: '登录中',
    请确认已阅读并同意隐私协议: '请确认已阅读并同意隐私协议',
    提示: '提示',
    '您的账号已到期，请联系管理员！': '您的账号已到期，请联系管理员！',
    取消: '取消',
    确定: '确定',
    智慧储能云平台: '智慧储能云平台',
    '驰硕-智慧储能云平台': '驰硕-智慧储能云平台',
    '浙江明度-工商业储能云平台': '浙江明度-工商业储能云平台',
    STE智慧储能云: 'STE智慧储能云',
    '云基慧-智慧储能云平台': '云基慧-智慧储能云平台',
    工商业储能数据云平台: '工商业储能数据云平台',
    智慧储能管控平台: '智慧储能管控平台'
  },
  //默认登录
  loginDefault: {
    智慧储能云平台: '智慧储能云平台'
  },
  //驰硕登录
  LoginChiShuo: {
    '驰硕-智慧储能云平台': '驰硕-智慧储能云平台'
  },
  //浙江明度登录
  LoginMingDu: {
    '浙江明度-工商业储能云平台': '浙江明度-工商业储能云平台'
  },
  //赛唯登录
  LoginMingDu: {},
  //三铁登录
  LoginSanTie: {
    STE智慧储能云: 'STE智慧储能云'
  },
  LoginUjoinWe: {
    '云基慧-智慧储能云平台': '云基慧-智慧储能云平台'
  },
  LoginWincle: {
    工商业储能数据云平台: '工商业储能数据云平台'
  },
  //大力
  LoginDaLi: {
    智慧储能管控平台: '智慧储能管控平台'
  }
}
export default loginZh
